export type FrameSubscriber = (now: number) => void;

const subscribers = new Set<FrameSubscriber>();
let animationFrame: number | null = null;

function runFrame(now: number): void {
  animationFrame = null;
  for (const subscriber of [...subscribers]) {
    subscriber(now);
  }
  if (subscribers.size > 0) {
    animationFrame = window.requestAnimationFrame(runFrame);
  }
}

/**
 * One requestAnimationFrame loop serves every mounted living mark. The returned
 * disposer is idempotent and stops the browser loop when its last subscriber
 * unmounts.
 */
export function subscribeFrame(subscriber: FrameSubscriber): () => void {
  subscribers.add(subscriber);
  if (animationFrame === null) {
    animationFrame = window.requestAnimationFrame(runFrame);
  }

  let subscribed = true;
  return () => {
    if (!subscribed) return;
    subscribed = false;
    subscribers.delete(subscriber);
    if (subscribers.size === 0 && animationFrame !== null) {
      window.cancelAnimationFrame(animationFrame);
      animationFrame = null;
    }
  };
}
